var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DynamicLinker',{attrs:{"item":_vm.item}},[_c('img',{staticClass:"w-100",attrs:{"src":_vm.item.picture,"alt":"banner"}})])}
var staticRenderFns = []

export { render, staticRenderFns }